import { selectors, actions } from 'app-webtech-core';
import { connect } from 'react-redux';
import { load, setID } from '../actions';
import { PlaybackSessionContainer } from './container';
import { playbackSessionPropertiesSelector } from '../selectors/properties';
import { playbackSessionIsReadyToLoadSelector } from '../selectors/isReadyToLoad';
import { getChannelByTimelineId } from './helpers/getChannelByTimelineId';
import { playerKindSelector } from '../../player/selectors/content';

const getContentId = (state) => {
  const props = selectors.player.properties(state);
  return props && props.content ? props.content.id : undefined;
};

const getCurrentData = (state) => {
  const { clips } = selectors.playbackSession.properties(state);
  if (clips && clips.length > 0 && clips[0]) {
    return {
      ...clips[0],
      channelID: getChannelByTimelineId(clips[0].timelineID, state), // TODO: memoize
    };
  }
  const { content } = selectors.player.properties(state);
  if (content && content.kind === 'viral') {
    return {
      clipID: content.id,
      channelID: 'viral',
    };
  }
  return {};
};

const mapStateToProps = (state, ownProps) => ({
  ID: playbackSessionPropertiesSelector(state, ownProps).ID,
  currentData: getCurrentData(state),
  currentPlayingContentId: getContentId(state),
  sessionUrl: playbackSessionPropertiesSelector(state, ownProps).sessionUrl || ownProps.sessionUrl,
  nextUpdate: playbackSessionPropertiesSelector(state, ownProps).nextUpdate,
  error: playbackSessionPropertiesSelector(state, ownProps).error,
  isReadyToLoad: playbackSessionIsReadyToLoadSelector(state, ownProps),
  playerStatus: selectors.player.properties(state).status,
  kind: playerKindSelector(state),
  prevVodContent: selectors.location.properties(state).prev,
  vodPayload: selectors.location.properties(state).payload,
  videoLoaded: selectors.application.properties(state).videoLoaded,
  isClipEnded: selectors.player.properties(state).clipIsOver,
  isAutoPlay: selectors.guide.properties(state).isAutoPlay,
});

const mapDispatchToProps = (dispatch) => ({
  setID: (ID) => dispatch(setID({ ID })),
  load: () => dispatch(load()),
  setAutoPlay: (arg) => dispatch(actions.guide.setAutoPlay(arg)),
  episodeStart: (beaconArguments) => dispatch(actions.player.episodeStarts(beaconArguments)),
  episodeEnd: (beaconArguments) => dispatch(actions.player.episodeEnds(beaconArguments)),
  clipStart: (beaconArguments) => dispatch(actions.player.clipStarts(beaconArguments)),
  clipEnd: (beaconArguments) => dispatch(actions.player.clipEnds(beaconArguments)),
});

export const ConnectedPlaybackSession = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlaybackSessionContainer);
